import { push } from "connected-react-router";
import { useDispatch } from "react-redux";

const useTransferByCbu = () => {
    const dispatch = useDispatch();
    const handleOtherTransfer = (beneficiary) => {
        dispatch(
            push({
                pathname: `/transfers`,
                state: { tab: 1, beneficiary, fromContactPage: true },
            }),
        );
    };
    return { handleOtherTransfer };
};

export default useTransferByCbu;
